import { Box } from "@mui/material";
import Whatsapp from "@/assets/icons/lead-page/whatsapp";
import { handleContactWhatsapp } from "@/modules/common/utils";

const ContactWhatsapp = ({ phoneNumber }: { phoneNumber?: string }) => {
  return (
    <Box
      sx={{
        cursor: "pointer",
      }}
      onClick={() => handleContactWhatsapp(phoneNumber)}
    >
      <Whatsapp />
    </Box>
  );
};

export default ContactWhatsapp;
